import React, { useEffect, useState } from 'react';
import { Button, IconButton } from '@material-ui/core';

import CloseIcon from '../../../components/shared/Icons/CloseIcon';
import {
  FormDescriptionMaxLength,
  RESPONSE_STATUS,
} from '../../../helpers/consts';

import LoadingIcon from '../../../components/shared/LoadingIcon';
import { StyledTextField } from '../../../components/shared/Inputs/StyledInput';

import {
  Body,
  Footer,
  Header,
  ModalContainer,
} from './styles';

import { captureEvent } from '../../../analytics';
import { Category } from 'src/redux/categories/types';

type Props = {
  intl: any;
  closeModal: Function;
};

type DispatchProps = {
  saveCategoryRequest: Function;
  clearEditCategoryStepper: Function;
  clearEditCategory: Function;
};

type StateProps = {
  isLoading: boolean;
  saveStatus: string;
  saveError: string;
  category: Category;
};

const CreationModal: React.FC<Props & DispatchProps & StateProps> = ({
  intl,
  isLoading,
  saveStatus,
  saveError,
  category,
  saveCategoryRequest,
  clearEditCategoryStepper,
  clearEditCategory,
  closeModal,
}) => {
  const categoryClearState: { id: number | null, name: string } = { id: null, name: '' };

  const [categoryData, setCategoryData] = useState(categoryClearState);

  const handleClear = () => {
    setCategoryData(categoryClearState);
    clearEditCategory();
  };

  useEffect(() => {
    if (saveStatus === RESPONSE_STATUS.SUCCESS) {
      handleClear();
      closeModal();
    }
  }, [saveStatus]);

  useEffect(() => {
    setCategoryData({ id: category.id, name: category.name})
  }, [category])

  const isEditing = Boolean(category.id);

  return (
    <ModalContainer>
      <Header>
        <h2>
          {isEditing
            ? intl.formatMessage({ id: 'categories.edit.label' })
            : intl.formatMessage({ id: 'categories.create' })}
        </h2>
        <div>
          <IconButton className="filterIconButton" onClick={() => closeModal()}>
            <CloseIcon />
          </IconButton>
        </div>
      </Header>
      <Body>
        <section className="form">
          <div className="question">
            <StyledTextField
              label={`${intl.formatMessage({ id: 'categories.edit.field.name' })}`}
              type="text"
              disabled={false}
              inputProps={{ maxLength: FormDescriptionMaxLength }}
              onChange={e => setCategoryData({ ...categoryData, name: e.target.value })}
              value={categoryData.name}
              placeholder={intl.formatMessage({ id: 'categories.edit.field.name.placeholder' })}
            />
          </div>
        </section>
      </Body>
      <Footer>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            closeModal();
            captureEvent(isEditing ? 'cancelEditAction' : 'cancelCreateAction');
          }}
          style={{ width: 146 }}
        >
          {intl.formatMessage({ id: 'utils.cancel' })}
        </Button>
        <Button
          disabled={isEditing ? false : !Boolean(categoryData.name)}
          variant="contained"
          color="primary"
          onClick={() => saveCategoryRequest(categoryData)}
          style={{ width: 146, marginLeft: 16 }}
        >
          {isLoading ? (
            <LoadingIcon theme="light" size={24} />
          ) : (
            intl.formatMessage({ id: isEditing ? 'utils.edit' : 'categories.edit.save' })
          )}
        </Button>
      </Footer>
    </ModalContainer>
  );
}

export default CreationModal;
